import { Ref, ref } from 'vue'

const modals: Record<string, Ref<boolean>> = {}

export default function useModal(modalId: string) {
  if (!modals[modalId]) {
    modals[modalId] = ref(false)
  }

  const openModal = (id: string = modalId) => {
    modals[id].value = true
  }
  const closeModal = (id: string = modalId) => {
    modals[id].value = false
  }

  return {
    isOpen: modals[modalId],
    openModal,
    closeModal
  }
}
